import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/list/styles.scss';export default {
  "main": "_main_tr0lr_1",
  "header": "_header_tr0lr_7",
  "iconBox": "_iconBox_tr0lr_18",
  "icon": "_icon_tr0lr_18",
  "openedIcon": "_openedIcon_tr0lr_34",
  "row": "_row_tr0lr_38",
  "avatar": "_avatar_tr0lr_45",
  "col": "_col_tr0lr_50",
  "name": "_name_tr0lr_59",
  "profession": "_profession_tr0lr_64",
  "recordList": "_recordList_tr0lr_69"
};